var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"app-loader"},[_c('circle',{staticClass:"app-loader__circle",attrs:{"cx":"15","cy":"15","r":"8"}})])}
var staticRenderFns = []
export { render, staticRenderFns }